<template>
  <div class="sharePopup">
    <van-popup v-model="show" closeable>
      <img src="" alt="" class="shareImg" ref="shareImg">
      <p>长按保存海报到本地</p>
    </van-popup>
    <canvas ref="resultCanvas" style="display: none;"></canvas>
    <vueQr
      :text="shareUrl"
      :size="250"
      :margin="0"
      ref="qr"
      style="display: none"
    />
  </div>
</template>

<script>
import vueQr from "vue-qr";
export default {
  components: {
    vueQr,
  },
  data() {
    return {
      show: false,
      shareUrl: ''
    };
  },
  computed: {},
  created(){},
  methods: {
    open(url){
      this.shareUrl = url
      this.generateQRCodeAndMerge()
      this.show = true
    },
    async generateQRCodeAndMerge() {
      const imgSrc = require("@/static/images/joinus.jpg"); // 需要合并的图片路径

      // 生成二维码
      // const qrCanvas = await this.generateQRCode(qrData);
      // 加载图片
      const image = await this.loadImage(imgSrc);
      const qrCanvas = this.$refs.qr?.$el;
      // 合并图片
      this.mergeImages(qrCanvas, image);
    },
    async generateQRCode(data) {
      const qr = new QR(this.$refs.qrCanvas, { text: data });
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(this.$refs.qrCanvas);
        }, 100); // 等待一段时间让二维码渲染完成
      });
    },
    async loadImage(src) {
      return new Promise((resolve) => {
        const image = new Image();
        image.src = src;
        image.onload = () => resolve(image);
      });
    },
    mergeImages(qrCanvas, image) {
      const resultCanvas = this.$refs.resultCanvas;
      resultCanvas.width = Math.max(qrCanvas.width, image.width);
      resultCanvas.height = Math.max(qrCanvas.height, image.height);
  
      const ctx = resultCanvas.getContext('2d');
      const qrX = (image.width - qrCanvas.width) / 2;
      const qrY  = image.height - qrCanvas.height - 80;
      ctx.drawImage(image, 0, 0, image.width, image.height); // 绘制背景图片
      ctx.drawImage(qrCanvas, qrX, qrY, qrCanvas.width, qrCanvas.height); // 在适当位置绘制二维码

      // 可以在这里保存或显示合并后的图片
      this.$refs.shareImg.src = resultCanvas.toDataURL();
    },
  },
};
</script>

<style lang="scss" scoped>
.shareImg{
  display: block;
  width: 550px;
}
.sharePopup{
  .van-popup{
    overflow-y: visible;
    >p{
      position: absolute;
      color: #bcbcbb;
      text-align: center;
      font-size: 40px;
      width: 550px;
      bottom: -100px;
    }
  }
}
</style>
